import React from 'react';

import { Button } from 'js/components/common/Button';

export const ButtonLoginError = ({ children, ...props }) => (
    <Button view="primary" {...props}>
        {children}
    </Button>
);
